var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "17px",
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-Feather-(Neutral)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Versicherte---Filter-eingeklappt",
    transform: "translate(-1108.000000, -129.000000)",
    stroke: "#AFAFB1",
    className: "toggle",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1109.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Filter-Icon",
    points: "16 2 0 2 6.4 9.568 6.4 14.8 9.6 16.4 9.6 9.568"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.7f76cfdfb6ce31556e52bef6728a102e.svg";
export { ForwardRef as ReactComponent };